module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "gra2pes-ghg-nox-monthgrid-v1.thumbnails.total.1babd762.png";